import FloorSelect from './component';

export default FloorSelect;
